// extracted by mini-css-extract-plugin
module.exports = {"autohitel-widget":"AutoHitelWidget_autohitel-widget__10Z2Z","autohitel-widget--open":"AutoHitelWidget_autohitel-widget--open__8aMj4"};